import { render, staticRenderFns } from "./ScoreStatus.vue?vue&type=template&id=067abe42&scoped=true"
import script from "./ScoreStatus.vue?vue&type=script&lang=js"
export * from "./ScoreStatus.vue?vue&type=script&lang=js"
import style0 from "./ScoreStatus.vue?vue&type=style&index=0&id=067abe42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067abe42",
  null
  
)

export default component.exports